import { useMouseCapture } from "@/hooks/useMouseCapture";
import { useState } from "react";
import { getColorClass } from "../../../_Shared/getColorClass";
import { ProjectProgressBarHover } from "./Hover";
import { TaskCategoryProgress } from "@/interfaces/progress_types";

type ProjectProgressBarProps = {
    width: number   
    color: string
    category: string
    category_progress: TaskCategoryProgress
}
export function ProjectProgressBar({ width, color, category, category_progress }: ProjectProgressBarProps) {
    const [hover, setHover] = useState(false);

    const { mousePosition, handleMouseMove } = useMouseCapture();

    return (
        <div
            className="h-full relative"
            style={{ width: `${width}%` }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onMouseMove={handleMouseMove}
        >
            {hover && (
                <ProjectProgressBarHover
                    mousePosition={mousePosition}
                    category={category}
                    color={color}
                    category_progress={category_progress} />
            )}

            <div className={`absolute inset-0 ${getColorClass(color, 200)} opacity-30 transition-all duration-300 hover:brightness-125`} />

            <div
                className={`h-full ${getColorClass(color, 500)}`}
                style={{ width: `${category_progress.percent_complete}%` }}
            >
            </div>
        </div>
    );
}
